export default "/_next/static/media/hero-mob.5e016384dd5e6a4025a7e97fdfecac91.mp4";